import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Dropdown, DropdownButton } from "react-bootstrap";
import '../componentCss/webform.css';
import '../componentCss/sidebar.css';
import 'react-toastify/dist/ReactToastify.css';
import { getDashboardStatisticsAction, getFormDataListAction, getUpcomingEventAction, getPatientRecordDashboardAction, getAllRolesApi, getStaffListAction, getPivotedFormDataAction } from '../../Action/admin.action';
import { Link, useNavigate } from 'react-router-dom';
import config from '../../config/config';
import { decryptData } from './decrypt';
import propertise, { reportsFileds } from '../../config/properties';
import DataTable from 'react-data-table-component';
import toast from 'react-hot-toast';
import PivotTable from "./PivotTable";
import PivotTableSkeleton from "./PivotTableSkeleton";


const ReportDashboard = () => {

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(currentMonth);
    const [data, setData] = useState([]);

    const navigate = useNavigate()
    const [patients, setPatients] = useState([]);
    const [allRolesWithUsers, setAllRolesWithUsers] = useState([])
    const [allUsers, setAllUsers] = useState([])
    const [statistics, setStatistics] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [getPatientRecordDashboard, setGetPatientRecordDashboard] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [userRole, setUserRole] = useState(0);
    const [daysSinceLastUpdate, setDaysSinceLastUpdate] = useState(0);
    const [formFields, setFormFields] = useState([]);
    const [formList, setFormData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterStatus, setFilterStatus] = useState(false);
    const [pivotData, setPivotData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [searchTerms, setSearchTerms] = useState({
        FirstName: '',
        LastName: '',
        MrnNumber: '',
        MobileNumber: '',
        EmiratesIdNumber: '',
        PassportNumber: '',
        // selectRole: '',
        fieldValue: ''
    });

    useEffect(() => {
        getFormDataListAPI();
        getDashboardStatisticsAPI();
        getPatientRecordDashboardAPI();
        getRolesListAPI();
        // getFormDataListActionAPI();
        handleSearch();


    }, []);

    
    const handleSearch = async () => {
        setLoading(true);
        try{
            let res = await getPivotedFormDataAction({
                year: year, month: month
            });
            if (res.success) {
                setPivotData(res.data[0]["data"])
            }
        }catch (err) {
        }finally {
            setLoading(false);
        }
            
    }

    const handlePageChange = page => {
        setCurrentPage(page - 1);
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage)
    };

    const getPatientRecordDashboardAPI = async (fromDate, toDate) => {
        let res = await getPatientRecordDashboardAction({
            fromDate: fromDate, toDate: toDate
        });
        if (res.success) {
            let data = decryptData(res.data);
            setGetPatientRecordDashboard(data);
        }
    };

    const [formData1, setFormData1] = useState({
        from: '',
        to: '',
    });

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFormData1((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        const updatedData = {
            ...formData1,
            [name]: value,
        };

        getPatientRecordDashboardAPI(updatedData.from, updatedData.to)
    };

    // Fetch All the Roles, club all the roles with user like: {"Admin":["User1", "User2"], "RCM": ["User1", "User3"]}
        let getRolesListAPI = async () => {
            let res = await getAllRolesApi();
            let rolesData = [];
            let usersData = [];
            let result = [];
            if (res.success){
                rolesData = res.data
            }
            let user = await getStaffListAction();
            if (user.success){
                usersData = decryptData(user.data);
                setAllUsers(usersData)
            }
            rolesData.forEach(role => {
                const roleUsers = usersData.filter(user => user.roles.includes(role.name));
                const userNames = roleUsers.map(user => `${user.firstName} ${user.lastName}`);
            
                // Push the role and the corresponding users into the result array
                result.push({ 'name':role.name,  'roles': userNames });
            });
            setAllRolesWithUsers(result)

        }
    


    let getFormDataListAPI = async () => {
        let res = await getFormDataListAction({ id: propertise.NursesNotes });
        let pa = await getFormDataListAction({ id: propertise.patientAdmit });
            setIsLoading(false);
                    if (pa.success) {
                        let decryptedData = decryptData(pa.data?.fields);
                        
                        //
                        if (Array.isArray(decryptedData) && decryptedData.length > 2) {
                            decryptedData.splice(2, 1);  // Remove the 3rd item (index 2)
                        }
                        setPatients(decryptData(pa.data?.records))
                        // setFormData(decryptData(pa.data?.records))

                        // let da = decryptData(pa.data?.records);
                        // da.map((p,idx) => {
                        // })
                        // setTotalRows(pa.data.totalRows);
                        // setFilteredData(decryptData(res.data?.records));
                    }

        setIsLoading(false);
        if (res.success) {
            let decryptedData = decryptData(res.data?.fields);
            if (Array.isArray(decryptedData) && decryptedData.length > 2) {
                decryptedData.splice(2, 1);
            }

            setFormFields(decryptedData);
            setFormData(decryptData(res.data?.records));
            setTotalRows(res.data.totalRows);
            setFilteredData(decryptData(res.data?.records));
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSearchTerms({
            ...searchTerms,
            [name]: value,
        });
    };

    const handleFilter = () => {
      
        const { selectedPatientId, from, to, selectRole, selectUserName } = formData1;
        const selectedNames = selectRole && selectRole.trim() !== '' ? selectRole.split(',').map(name => name.trim()) : [];
        const tempFormList = [...formList];
      
        const filteredData = tempFormList.filter(entry => {
          const entryDate = new Date(entry.datetime);
      
          const matchesPatientId = selectedPatientId
            ? entry.mrnNumber?.trim().toLowerCase().includes(selectedPatientId.trim().toLowerCase())
            : true;
      
          const isWithinDateRange = (from && to)
            ? (entryDate >= new Date(from) && entryDate <= new Date(to))
            : true;
          const matchesStaffName = selectedNames.length > 0
            ? selectedNames.includes(entry.staffName)
            : true;
          const mactchesUserName = selectUserName
            ? entry.staffName?.trim().includes(selectUserName.trim())
            : true;

          return matchesPatientId && isWithinDateRange && matchesStaffName && mactchesUserName;
        });
      
        if (filteredData.length) {
          setFilterStatus(true);
          setFilteredData(filteredData);
        } else {
          toast.error("No records found for selected filters.");
          setFilteredData([]);
        }
      };
      
      

    const handleReset = () => {
        window.location.reload()
    }

    const getDashboardStatisticsAPI = async () => {
        let res = await getDashboardStatisticsAction();
        if (res.success) {
            let data = decryptData(res.data);
            setStatistics(data.statistics);
            setDaysSinceLastUpdate(data.daysSinceLastUpdate);
            setUserRole(data.userRole)
            if (parseInt(data.userRole) > 2) {
                getUpcomingEventAPI()
            }
        }
    };

    const getUpcomingEventAPI = async () => {
        let res = await getUpcomingEventAction();
        if (res.success) {
            setUpcomingEvents(decryptData(res.data));
        }
    };

    const columns = [
        {
            name: '#',
            cell: (row, index, column, id) => {
                return (index + 1) + (currentPage * rowsPerPage);
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: "Session ID",
            selector: (row) => `${row.recordId ? row.recordId : 'NA'}`,
            sortable: true,
        },
        {
            name: "Session Date",
            selector: (row) => `${row.datetime ? row.datetime : 'NA'}`,
            sortable: true,
        },
        {
            name: "MRN Number",
            selector: (row) => `${row.mrnNumber ? row.mrnNumber : 'NA'}`,
            sortable: true,
        },
        {
            name: "Patient Name",
            selector: (row) => {
                const patient = patients.find(patient => patient.mrnNumber === row.mrnNumber);
                return patient ? `${patient[16]} ${patient[18]}` : 'NA';  // Adjust this based on how you store patient names
            },
            sortable: true,
        },
        {
            name: "Administered User",
            selector: (row) => `${row.assignedStaffNames ? row.assignedStaffNames : 'NA'}`,
            sortable: true,
        },

        {
            name: "Notes",
            selector: (row) => `${row[1362] ? row[1362] : 'NA'}`,
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => `${row[20] ? row[20] : ''}`,
            sortable: true,
        },
        // {
        //     name: "Status",
        //     selector: (row) => (
        //         <span style={{ color: row.status == 1 ? 'green' : 'red' }}>
        //             {row.status == 1 ? 'Active' : 'Discharged'}
        //         </span>
        //     ),
        //     sortable: true,
        // },
        // {
        //     name: "Action",
        //     selector: (row) => (
        //         <span>
        //             <DropdownButton id="dropdown-basic-button" title="Actions" className="btn-primary">
        //                 <Dropdown.Item onClick={() => handleRowClick(row)}>View</Dropdown.Item>
        //                 <Dropdown.Item onClick={() => handlePatientDischargeTransfer(row, propertise.patientDischarge)}>Discharge</Dropdown.Item>
        //                 <Dropdown.Item onClick={() => handlePatientDischargeTransfer(row, propertise.patientTransfer)}>Transfer</Dropdown.Item>
        //             </DropdownButton>
        //         </span>
        //     ),
        //     sortable: true,
        // },
    ];

    const handleRowClick = (e) => {
        localStorage.setItem('recordId', e.recordId);
        localStorage.setItem('patientMrnNumber', e.mrnNumber);
        window.location.href = `${config.baseUrl}viewRecordReport/${propertise.preHDformId},${propertise.duringHDformId},${propertise.postHDformId}/"${e.mrnNumber}"/Hemodialysis Treatment/isSearch`
    }

    const handlePatientDischargeTransfer = (e, formId) => {
        localStorage.setItem('recordId', e.recordId);
        localStorage.setItem('patientMrnNumber', e.mrnNumber);
        window.location.href = `${config.baseUrl}form-submission/${formId}/${e.recordId}`
    }

    return (
        <div id="content">
            <Container fluid className="p-4">
                <Row>
                    <Col md={6} sm={6} className="mb-3">
                        <h5 className="headtitle">A-46 PATIENT NOTE REPORT</h5>
                    </Col>

                </Row>

                <div style={{ marginBottom: "20px", display: "flex", gap: "10px", alignItems: "center" }}>
                    <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
                    {[...Array(6)].map((_, i) => {
                        const y = currentYear - 3 + i;
                        return <option key={y} value={y}>{y}</option>;
                    })}
                    </select>

                    <select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
                    {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                        {new Date(0, i).toLocaleString('default', { month: 'long' })}
                        </option>
                    ))}
                    </select>

                    <button onClick={handleSearch}>Search</button>
                </div>



                {loading ? (
                    <PivotTableSkeleton rows={4} columns={28} />
                ) : (
                    <PivotTable data={pivotData} />
                )}
                {/* <Row className="text-center mb-4">
                    <Col md={4} sm={6}>
                        <Card className="statistic-card">
                            <Card.Body>
                                <Card.Title>No. of Admission</Card.Title>
                                <Card.Text className="count">{getPatientRecordDashboard.totalPatient}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} sm={6}>
                        <Card className="statistic-card">
                            <Card.Body>
                                <Card.Title>No. of Discharged</Card.Title>
                                <Card.Text className="count">{getPatientRecordDashboard.dischargePatient}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} sm={6}>
                        <Card className="statistic-card">
                            <Card.Body>
                                <Card.Title>No. of Active Patient</Card.Title>
                                <Card.Text className="count">{getPatientRecordDashboard.activePatient}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> */}

              
                {/* <Row> */}
                    
                    {/* <Col className={userRole > 2 ? 'border p-3 m-2 col-md-8' : 'border p-3 m-2 col'} style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}> */}
                    {/* <Col className={'border p-3 m-2 col-md-12'} style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}> */}
                      
                        {/* <Row> */}
                        {/* <Col md={3} sm={3} className="mb-3">
                                <Form.Group className="fieldbox h-auto px-2">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        className="form-control"
                                        name="from"
                                        value={formData1.from}
                                        onChange={handleChange1}
                                    />
                                </Form.Group>
                            </Col> */}
                            
                            {/* <Col md={3} sm={3} className="mb-3">
                                <Form.Group className="fieldbox h-auto px-2">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        className="form-control"
                                        name="to"
                                        min={formData1.from}

                                        value={formData1.to}
                                        onChange={handleChange1}
                                    />
                                </Form.Group>
                            </Col> */}

                            {/* <Col md={3} sm={3} className="mb-3">
                                <Form.Group className="">
                                    <Form.Label>Paitent</Form.Label>
                                    <Form.Select
                                        className="form-select"
                                        value={searchTerms.dropdownValue}
                                        onChange={handleChange}
                                        name="dropdownValue"
                                        aria-label="Default select example"
                                    >
                                        <option value="" disabled>Select</option>
                                        <option value="1">Active</option>
                                        <option value="2">Discharged</option>
                                        <option value="3">Deceased</option>
                                        <option value="4">Pre-admit</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}

                            {/* <Col md={3} sm={3} className="mb-3">
                                <Form.Group className="">
                                    <Form.Label>Patient Name</Form.Label>
                                    <Form.Select
                                        className="form-select"
                                        name="selectedPatientId"
                                        value={searchTerms.selectedPatientId}
                                        onChange={handleChange1}
                                    >
                                        <option value="">Select Patient</option>
                                        {patients.map((p, idx) => (
                                            <option key={idx} value={p.mrnNumber}>{p[16]} ({p.mrnNumber})</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}


                            {/* <Col md={3} sm={3} className="mb-3">
                                <Form.Group className="fieldbox h-auto px-2">
                                    <Form.Label>Role</Form.Label>
                                    <Form.Select
                                        className="form-select"
                                        name="selectRole"
                                        value={searchTerms.selectRole}
                                        onChange={handleChange1}
                                    >
                                        <option value="">Select Role</option>
                                        {allRolesWithUsers.map((p, idx) => (
                                            <option key={idx} value={p.roles}>{p.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}
                            
                            {/* <Col md={3} sm={3} className="mb-3">
                                <Form.Group className="fieldbox h-auto px-2">
                                    <Form.Label>Select Username</Form.Label>
                                    <Form.Select
                                    className="form-select"
                                    name="selectUserName"
                                    value={searchTerms.selectUserName}
                                    onChange={handleChange1}
                                    >
                                    <option value="">Select Name</option>
                                    {allUsers.map((p, idx) => {
                                        const fullName = `${p.firstName} ${p.lastName}`.trim();
                                        return (
                                        <option key={idx} value={fullName}>
                                            {fullName}
                                        </option>
                                        );
                                    })}
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}


                            {/* {['FirstName', 'LastName', 'MrnNumber', 'EmiratesIdNumber','fieldValue'].map((field, index) => (
                                <Col key={index} md={4} sm={6} className="mb-3">
                                    <Form.Group className="fieldbox h-auto px-2">
                                        <Form.Label>{field.replace(/([A-Z])/g, ' $1')}</Form.Label>
                                        <Form.Control
                                            type={field === 'mobileNumber' ? 'number' : 'text'}
                                            placeholder={`Search By ${field.replace(/([A-Z])/g, ' $1')}`}
                                            className="form-control"
                                            name={field}
                                            value={searchTerms[field]}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            ))} */}
                            
                           
                        {/* </Row> */}
                        {/* <Row> */}
                            {/* <Col className="d-flex">
                                <div className="">
                                    <Button className="px-3 py-2 btn-sm btn-secondary-btn3 fs-6 mt-4" onClick={() => handleFilter()}>Search</Button>
                                </div>
                                &nbsp;
                                <div >
                                    <Button className="px-3 py-2 btn-sm btn-secondary-btn3 fs-6 mt-4" onClick={() => handleReset()}>Reset</Button>
                                </div>
                            </Col> */}

                        {/* </Row> */}
                        {/* <hr /> */}
                        {/* <Row>
                            <Col>
                                <div className='dashboardTbl'>

                                    <DataTable
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                    onRowClicked={handleRowClick}
                                    />
                                </div>
                            </Col>
                        </Row> */}
                    {/* </Col> */}
                {/* </Row> */}
            </Container>
        </div>
    );
};

export default ReportDashboard;
